import { AccountPopover } from './AccountPopover'
import { PageMetaDataSelector } from '../../store/pageMetaData'
import { AppBar, Stack, Toolbar, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

export const BaseHeader = () => {
    const theme = useTheme()

    const pageName = useSelector(PageMetaDataSelector.getPageName)

    return (
        <AppBar
            elevation={0}
            position="fixed"
            sx={{
                pl: '270px',
                height: '64px',
                background: 'white',
                borderBottom: `1px solid ${theme.palette.grey[200]}`,
            }}
        >
            <Toolbar sx={{ background: 'white', py: 1 }}>
                <Stack width="100%" direction="row" justifyContent="space-between">
                    <Typography variant="h6" color="secondary" fontSize="1.5rem">
                        {pageName}
                    </Typography>

                    <AccountPopover />
                </Stack>
            </Toolbar>
        </AppBar>
    )
}